import { useState } from 'react';

const useArray = (defaults = []) => {
  const [items, setItems] = useState(defaults);

  const replaceItem = (item, index) => {
    items[index] = item;
    setItems([...items]);
  };

  return [items, replaceItem, setItems];
};

export default useArray;
